import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../api';

function ResetPassword() {
  const [searchParams]              = useSearchParams();
  const navigate                    = useNavigate();
  const [token, setToken]           = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPwd, setConfirmPwd] = useState('');
  const [message, setMessage]       = useState('');
  const [error, setError]           = useState('');
  const [loading, setLoading]       = useState(false);
  const [success, setSuccess]       = useState(false);

  useEffect(() => {
    // ✅ URL-ல் ?token= எடுக்கிறோம்
    const t = searchParams.get('token');
    if (!t) {
      setError('❌ Invalid link! Token இல்லை.');
    } else {
      setToken(t);
    }
  }, [searchParams]);

  const handleReset = async () => {
    setError('');
    setMessage('');

    if (!newPassword || newPassword.length < 6) {
      setError('Password குறைந்தது 6 characters வேணும்!');
      return;
    }
    if (newPassword !== confirmPwd) {
      setError('Passwords match ஆகவில்லை!');
      return;
    }

    setLoading(true);
    try {
      await api.post(
        `/auth/reset-password?token=${token}&new_password=${encodeURIComponent(newPassword)}`
      );
      setSuccess(true);
      setMessage('✅ Password reset successful!');
      // 3 seconds பிறகு login page-க்கு போ
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(
        err.response?.data?.detail ||
        '❌ Invalid or expired link! புது reset request பண்ணுங்கள்.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.logo}>📦 JSMSTOCK</h1>
        <p style={styles.tagline}>உங்கள் கடை, உங்கள் கையில்!</p>
        <h2 style={styles.title}>🔑 புது Password Set</h2>

        {message && (
          <div style={styles.successBox}>
            {message}
            <p style={{ fontSize: '13px', marginTop: '6px' }}>
              3 seconds-ல் Login page-க்கு போகிறீர்கள்...
            </p>
          </div>
        )}
        {error && <div style={styles.errorBox}>{error}</div>}

        {!success && token && (
          <>
            <input
              style={styles.input}
              placeholder="புது Password"
              type="password"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
            />
            <input
              style={styles.input}
              placeholder="Password மீண்டும் type பண்ணுங்கள்"
              type="password"
              value={confirmPwd}
              onChange={e => setConfirmPwd(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleReset()}
            />
            <button
              style={{ ...styles.button, opacity: loading ? 0.7 : 1 }}
              onClick={handleReset}
              disabled={loading}
            >
              {loading ? '⏳ Please wait...' : '✅ Password Update பண்ணு'}
            </button>
          </>
        )}

        <p
          style={styles.back}
          onClick={() => navigate('/login')}
        >
          ← Back to Login
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f0f2f5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '15px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '400px',
    textAlign: 'center',
  },
  logo:    { color: '#2c3e50', marginBottom: '5px' },
  tagline: { color: '#666', marginBottom: '20px', fontSize: '14px' },
  title:   { color: '#2c3e50', marginBottom: '20px' },
  input: {
    display: 'block', width: '100%',
    padding: '12px', margin: '8px 0',
    borderRadius: '8px', border: '1px solid #ddd',
    fontSize: '16px', boxSizing: 'border-box',
  },
  button: {
    backgroundColor: '#2c3e50', color: 'white',
    padding: '12px', border: 'none',
    borderRadius: '8px', fontSize: '16px',
    width: '100%', cursor: 'pointer', marginTop: '10px',
  },
  successBox: {
    background: '#e8f8f0', border: '1px solid #27ae60',
    color: '#27ae60', padding: '14px', borderRadius: '8px',
    marginBottom: '16px', fontWeight: '600',
  },
  errorBox: {
    background: '#fff0f0', border: '1px solid #e74c3c',
    color: '#e74c3c', padding: '14px', borderRadius: '8px',
    marginBottom: '16px',
  },
  back: {
    color: '#3498db', cursor: 'pointer',
    marginTop: '16px', fontSize: '14px',
  },
};

export default ResetPassword;

